//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import IncomingGoods from './components/incomingGoods'
export default {
  components:{
    IncomingGoods
  },
  data() {
    return {
      shopName:'',
      initShopArea:'全部',
      shopAreaList:[
        {value: '全部',label: '全部'}, 
        {value: '锦江',label: '锦江'}, 
        {value: '青羊',label: '青羊'}, 
        {value: '金牛',label: '金牛'}, 
        {value: '武侯',label: '武侯'}, 
        {value: '成华',label: '成华'}, 
        {value: '龙泉驿',label: '龙泉驿'}, 
        {value: '青白江',label: '青白江'}, 
        {value: '新都',label: '新都'},
        {value: '温江',label: '温江'}, 
        {value: '双流',label: '双流'}, 
        {value: '邯郸区',label: '邯郸区'}, 
        {value: '简阳',label: '简阳'}, 
        {value: '都江堰',label: '都江堰'}, 
        {value: '彭州',label: '彭州'}, 
        {value: '邛崃',label: '邛崃'}, 
        {value: '崇州',label: '崇州'}, 
        {value: '金堂',label: '金堂'}, 
        {value: '大邑',label: '大邑'}, 
        {value: '浦江',label: '浦江'}, 
        {value: '新津',label: '新津'}, 
        {value: '高新区',label: '高新区'}, 
        {value: '天府新区',label: '天府新区'}, 
        {value: '高新西区',label: '高新西区'}
      ],
      bayList:[
        {value:'-1',label:'全部'},
        {value:'0',label:'未发送'},
        {value:'1',label:'已发送'},
      ],
      bayValue:'0',
      tableData:[],
      pageSizes:[5, 10, 15, 20],
      pageSizeValue:5,
      total:0,
      pageNo:1,
      compile:false,
      resData:'',
    }
  },
  mounted(){
    this.info()
  },
  methods:{
    info(state = false){
      if(state){
        this.pageNo = 1
      }
      // this.$axios.get('/mtea/stock/stockOutList', {params: data}).then(res => {
      let data = {
        pageNo:this.pageNo,
        pageSize:this.pageSizeValue,
      }
      if(this.bayValue !== '-1'){
        data.orderStatus = this.bayValue
      }
      if(this.shopName !== ''){
        data.shopName = this.shopName
      }
      if(this.initShopArea !== '全部'){
        data.shopArea = this.initShopArea
      }
      this.tableData = []
      this.$axios.post('/mtea/stock/accept/getList', data).then(res => {
        for(let j = 0;j<res.records.length;j++){
          res.records[j].getTime = (new Date(res.records[j].endTime).getTime())
        }
        for (var i = 0; i < res.records.length-1; i++) {
          for (var j = 0; j < res.records.length - 1 - i; j++) {
              // 相邻元素两两对比，元素交换，大的元素交换到后面
              if (res.records[j].getTime < res.records[j + 1].getTime) {
                  var temp = res.records[j];
                  res.records[j] = res.records[j+1];
                  res.records[j+1] = temp;
              }
          }
        }
        this.tableData = res.records
        this.total = res.total
      }).catch((err)=>{
        console.log(err)
        // this.tableData = []
        // this.total = 0
        // this.pageSize = 0
      })

    },
    lookFun(row){
      this.compile=true
      row.itemList.forEach(e => {
        if(typeof e.goodsExtra === 'string')
        e.goodsExtra = JSON.parse(e.goodsExtra)
      });
      this.resData = row

    },
    sizeChange(num){
      this.pageSizeValue = num
      this.info()
    },
    currentChange(num){
      this.pageNo = num
      this.info()
    },
    lookClick(row){
      console.log(row)
    },
    pastClick(row){
      console.log(row)
    },
    invSubState(){
      this.compile = false
      this.info()
    },
  },
}
